import React, { useState, useEffect, useCallback } from "react";
import axios from '../../api/apiClient';

import {
  CreateTableNew as CreateTable,
  SearchBar
} from '../../common/APICommon';
import { token, domain } from '../Security';
import loadingSpinner from './../../assets/loading.gif';
// icon
import CloseIcon from "@mui/icons-material/Close";
import ErrorIcon from '@mui/icons-material/Error';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EditIcon from '@mui/icons-material/Edit';

function EmployeeRequestAccess({ user, isHideSideMenu }) {

  var headers = [
    "ID",
    "Access Type",
    "Is Requester",
    "Is Approver",
    "Actions"
  ]
  var accessors = [
    "id",
    "description",
    "isEmployeeRequestRequester",
    "isEmployeeRequestApprover",
    "actions"
  ]

  const [currentPage, setCurrentPage] = useState(1);
  const [loading, setLoading] = useState(false);
  const [loadingRequest, setLoadingRequest] = useState(false);
  const [data, setData] = useState([]);
  const [selectedData, setSelectedData] = useState(null);

  const [accessType, setAccessType] = useState(""); // "requester", "approver", or ""

  const resetLocalVariables = () => {
    setAccessType("");
    setSelectedData(null);
  }

  // Retrieve
  const [filterData, setFilterData] = useState([]);
  //Update
  const [showEditForm, setShowEditForm] = useState(false);
  //Request Messages -start
  const [showRequestMessage, setShowRequestMessage] = useState(false);
  const [requestMessage, setRequestMessage] = useState("");
  const [isSuccess, setIsSuccess] = useState("");

  useEffect(() => {
    if (showRequestMessage) {
      const timeoutId = setTimeout(() => {
        setShowRequestMessage(false);
      }, 5000);

      return () => clearTimeout(timeoutId);
    }

  }, [showRequestMessage]);

  function GenerateMessage({ form, message, isSuccess }) {
    return (
      <>
        <div className={`modal-overlay toggleMessage-overlay ${form ? 'open' : ''}`}>
          {form && (
            <div className="modal toggleMessage" style={{ backgroundColor: isSuccess ? "#E0FFDC" : "#ffd0c5" }}>
              <div className='column'>
                {isSuccess ?
                  <div className='request_title row' style={{ fontWeight: "bold", color: "green", alignItems: "center" }}>
                    <CheckCircleIcon />
                    <span >{"SUCCESS MESSAGE"}</span>
                  </div>
                  :
                  <div className='request_title row' style={{ fontWeight: "bold", color: "#DD5746", alignItems: "center" }}>
                    <ErrorIcon />
                    <span>{"ERROR MESSAGE"}</span>
                  </div>
                }
                <span style={{ textAlign: "center", padding: "10px 0", color: isSuccess ? "green" : "#DD5746" }}>{message}</span>
              </div>
            </div>
          )}
        </div>
      </>
    );
  }
  //Request Messages -end

  const apiUrl = domain + "/api/AccessTemplate/employee-request-access";

  const fetchData = useCallback(async () => {
    try {
      setLoading(true);
      const response = await axios.get(apiUrl, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })
      setData(response.data);
      setFilterData(response.data);
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  }, [apiUrl]);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const handleFilter = (value) => {
    setCurrentPage(1);
    const lowercaseValue = value.toLowerCase();
    var res = filterData.filter((f) =>
      f?.description.toLowerCase().includes(lowercaseValue)
    );
    setData(res);
  };

  const handleUpdate = async (event) => {
    event.preventDefault();

    const data = {
      isEmployeeRequestRequester: accessType === "requester",
      isEmployeeRequestApprover: accessType === "approver"
    };

    try {
      setLoadingRequest(true);
      await axios.put(apiUrl + `/${selectedData.id}`, data, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      });

      setShowEditForm(false);
      await fetchData();
      console.log('Data updated successfully', selectedData.id, data);
      setShowRequestMessage(true);
      setIsSuccess(true);
      setRequestMessage("Access template updated successfully!");
    } catch (error) {
      console.error('There was a problem updating data:', error);
      setShowRequestMessage(true);
      setIsSuccess(false);
      const errorMessage = error.response?.data?.message || "Failed to update access template";
      setRequestMessage(errorMessage);
    } finally {
      setLoadingRequest(false);
    }

    setShowEditForm(false);
  };

  const editHandleClick = (data) => {
    setSelectedData(data);

    // Determine the current access type based on the data
    if (data.isEmployeeRequestRequester) {
      setAccessType("requester");
    } else if (data.isEmployeeRequestApprover) {
      setAccessType("approver");
    } else {
      setAccessType(""); // Neither is selected
    }

    openEditHandleClick();
  };

  const openEditHandleClick = () => {
    setShowEditForm(true);
  };

  const closeEditHandleClick = () => {
    setShowEditForm(false);
    resetLocalVariables();
  };

  const formatBooleanValue = (value) => {
    return value ? "Yes" : "No";
  };

  const actions = [
    {
      name: "Edit",
      tooltip: "edit",
      icon: <EditIcon fontSize="small" />,
      className: "bg-green-500 hover:bg-green-600 flex items-center",
      function: editHandleClick,
      visible: true,
    },
  ];

  return (
    <div>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="MainteInfo shadow-xl">
            <div className="mainteHeader">
              <div className='sub-title row'>
                <span style={{ padding: "0 5px 0 0", color: "#b0b0b0" }}>{"Maintenance >"} </span>
                <span style={{ borderBottom: "1px solid black" }}>{"Employee Request Access"}</span>
              </div>
              <h3>Employee Request Access</h3>
            </div>
            <div className='p-4 space-y-4'>
              <SearchBar handleFilter={handleFilter} />

              <CreateTable
                tableName={"EmployeeRequestAccess"}
                headers={headers}
                accessors={accessors}
                data={data}
                actions={actions}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                itemsPerPage={10}
                totalItems={data?.length}
              />
            </div>
          </div>
        </div>
      </div>
      <AddEditForm
        isOpen={showEditForm}
        onClose={closeEditHandleClick}
        description={selectedData?.description || ""}
        accessType={accessType} setAccessType={setAccessType}
        handleSubmit={handleUpdate}
        modalName={"Update Employee Request Access"}
      />
      <GenerateMessage
        form={showRequestMessage}
        message={requestMessage}
        isSuccess={isSuccess}
      />
      {loadingRequest || loading ? (
        <div
          style={{
            position: "fixed",
            top: "0",
            left: "0",
            width: "100vw",
            height: "100vh",
            zIndex: "2000",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            backgroundColor: "#ffffff59",
          }}
        >
          <img src={loadingSpinner} alt="Loading..." />
        </div>
      ) : (
        <></>
      )}
    </div>
  )
}

function AddEditForm({
  isOpen,
  modalName,
  onClose,
  description,
  accessType, setAccessType,
  handleSubmit
}) {

  const submit = (e) => {
    e.preventDefault();
    handleSubmit(e);
  };

  const handleClose = () => {
    onClose();
    setAccessType("");
  };

  const handleAccessTypeChange = (event) => {
    setAccessType(event.target.value);
  };

  if (!isOpen) return null;

  return (
    <>
      <div
        role="dialog"
        aria-modal="true"
        className="fixed inset-0 z-[10000] bg-black/50 flex items-center justify-center p-3 text-gray-700 overflow-auto"
      >
        <div className="bg-gray-50 w-full md:w-[90%] lg:w-[50%] rounded-lg shadow-xl h-auto flex flex-col relative">

          {/* Header */}
          <div className="flex justify-between items-center px-6 py-2 border-b border-gray-200 sticky top-0 bg-white z-10 rounded-t-lg shadow-sm">
            <h2 className="text-xl font-semibold text-gray-800 flex items-center space-x-2">
              <span className="text-xl text-gray-600">{modalName}</span>
            </h2>

            <button
              onClick={handleClose}
              className="text-gray-400 hover:text-gray-700 transition-colors p-1 bg-transparent border-none"
              aria-label="Close modal"
            >
              <CloseIcon fontSize="medium" />
            </button>
          </div>

          {/* Body */}
          <div className="p-6 overflow-y-auto flex-grow">

            {/* Access Type Display */}
            <div className="mb-6 border border-gray-300 rounded-lg bg-white px-4 shadow-sm">
              <div className="py-1 border-b border-gray-300">
                <h3 className="font-medium text-gray-700">Access Type Information</h3>
              </div>
              <div className="pb-3">
                <div className="grid grid-cols-1 gap-2 pt-3">
                  <div className="info-item-input">
                    <input
                      placeholder="Access Type Description"
                      value={description}
                      disabled={true}
                      className="w-full p-2 border border-gray-300 rounded bg-gray-100 text-gray-600 box-border"
                    />
                  </div>
                  <span className="text-xs text-gray-500 italic">
                    Access Type cannot be modified
                  </span>
                </div>
              </div>
            </div>

            {/* Employee Request Access Role Selection */}
            <div className="border border-gray-300 rounded-lg bg-white px-4 shadow-sm">
              <div className="py-1 border-b border-gray-300">
                <h3 className="font-medium text-gray-700">Select Employee Request Access Role</h3>
              </div>
              <div className="pb-3 pt-3">
                <div className="flex flex-col gap-3">
                  <label className="flex items-center space-x-3 cursor-pointer p-2 hover:bg-gray-50 rounded">
                    <input
                      type="radio"
                      name="accessType"
                      value="requester"
                      checked={accessType === "requester"}
                      onChange={handleAccessTypeChange}
                      className="h-4 w-4 text-blue-600"
                    />
                    <span className="text-gray-800 font-medium">Requester</span>
                  </label>

                  <label className="flex items-center space-x-3 cursor-pointer p-2 hover:bg-gray-50 rounded">
                    <input
                      type="radio"
                      name="accessType"
                      value="approver"
                      checked={accessType === "approver"}
                      onChange={handleAccessTypeChange}
                      className="h-4 w-4 text-blue-600"
                    />
                    <span className="text-gray-800 font-medium">Approver</span>
                  </label>

                  <label className="flex items-center space-x-3 cursor-pointer p-2 hover:bg-gray-50 rounded">
                    <input
                      type="radio"
                      name="accessType"
                      value=""
                      checked={accessType === ""}
                      onChange={handleAccessTypeChange}
                      className="h-4 w-4 text-blue-600"
                    />
                    <span className="text-gray-800 font-medium">None</span>
                  </label>
                </div>
              </div>
            </div>

          </div>

          {/* Footer */}
          <div className="flex justify-end space-x-2 p-5 border-t border-gray-200 bg-white shadow-sm">
            <button
              onClick={handleClose}
              className="bg-gray-400 hover:bg-gray-500 text-white px-4 py-2 rounded border-none cursor-pointer transition-colors"
            >
              Cancel
            </button>

            <button
              onClick={submit}
              className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded border-none cursor-pointer transition-colors"
            >
              Save
            </button>
          </div>

        </div>
      </div>
    </>
  );
}

export default EmployeeRequestAccess